<template>
  <!-- 主區域底層模板 -->

  <section class="drawer-layout Jost">
    <!-- 左邊 -->
    <section class="drawer-layout__left">
      <div class="drawer-layout__left-scroll">
        <!-- <div class="drawer-layout__left-header">
          <div
            >預約時間：
            <span style="color:#000000">2023/09/01 ~ 2023/09/03</span>
          </div>
          <div
            >服務地點：
            <span style="color:#000000">中山店</span>
          </div>
          <div
            >已選房型：
            <span style="color:#000000">小捲尾精品房 ＆ 輕奢經典房</span>
          </div>
        </div> -->
        <div class="drawer-layout__left-content">
          <el-button icon="el-icon-back" round style="width: fit-content; margin-bottom: 18px;" @click="$emit('back-step', 1)">
            重新搜尋客戶
          </el-button>
          <!-- 客戶資訊 -->
          <CustomerInfo :info="currentMemberInfo" :currentStep="currentStep" style="margin-bottom: 18px;" @update="fetchCurrentMember" @merge-info="onMergeMemberInfo" />
          <!-- 選擇住宿列表 -->
          <AccommodationList :info="accommodationInfo" :currentStep="currentStep" :mode="'edit'" style="margin-bottom: 18px;" />
        </div>
      </div>
    </section>

    <!-- 右邊 -->
    <section class="drawer-layout__right">
      <template v-if="rightPanelView === 'list'">
        <el-button @click="isAddPetDrawerShow = true" round type="primary" icon="el-icon-plus" style="margin:16px;margin-bottom:0px; width:fit-content">新增寵物</el-button>
        <div class="drawer-layout__right-scroll">
          <!-- 選擇寵物 -->
          <SelectPetListPartial
            :info="petList"
            :eligiblePets="eligiblePets"
            :selectedPets="selectedPets"
            :currentMaxAccommodates="currentMaxAccommodates"
            :availableCategoryIds="availableCategoryIds"
            @update:selectedPets="handleSelectedPets"
            @view-pet="onClickViewPet"
            style="margin-bottom:18px"
            :loading="isLoading"
          />
          <!-- 新增寵物 -->
          <PetCreatePartial v-model="isAddPetDrawerShow" :member-info="currentMemberInfo" @close="fetchGetMemberPets" />
        </div>
      </template>
    </section>

    <!-- 寵物資訊 Drawer -->
    <PetSidePanelPartial
      :visible.sync="isPetDetailDrawerShow"
      :pet-detail="selectedPetDetail"
      :initial-tab="petInfoActiveTab"
      mode="create"
      @close="handleClosePetDetail"
      @updated="onPetInfoUpdated"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import CustomerInfo from './partials/CustomerInfoPartial.vue'
import AccommodationList from './partials/AccommodationListPartial.vue'
import SelectPetListPartial from './partials/SelectPetListPartial.vue'
import PetCreatePartial from './partials/PetCreatePartial.vue'
import PetSidePanelPartial from './partials/PetSidePanelPartial.vue'
import PetCommentList from '@components/PetCommentList'

import API from '../../api'
import { fetchMemberShortWithSummary } from '@utils/memberV2Fetch'

export default {
  name: 'Step2hotelBooking',
  components: {
    CustomerInfo,
    AccommodationList,
    SelectPetListPartial,
    PetCreatePartial,
    PetSidePanelPartial,
    PetCommentList,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      petList: [],
      isAddPetDrawerShow: false,
      isPetDetailDrawerShow: false,
      isLoading: false,
      rightPanelView: 'list', // list | pet
      petDetailCache: {},
      petInfoActiveTab: 'information',
      petInfoTabs: [{ name: 'information', label: '寵物資訊' }, { name: 'service', label: '歷史紀錄' }, { name: 'currentService', label: '服務紀錄' }],
      petInfoLoading: false,
      selectedPetDetail: {},
    }
  },
  computed: {
    eligiblePets() {
      if (!this.petList) return []
      return this.petList.filter((pet) => this.availableCategoryIds.includes(pet.category.id))
    },
    selectedPetId() {
      if (this.selectedPetDetail && this.selectedPetDetail.id) return this.selectedPetDetail.id
      return this.petList && this.petList.length ? this.petList[0].id : null
    },
    dummyOrder() {
      return {
        id: null,
        uuid: null,
        displayId: null,
        pet: this.selectedPetDetail,
        petId: this.selectedPetId,
      }
    },
    ...mapGetters('hotel/order', ['currentMemberInfo', 'accommodationInfo', 'currentMaxAccommodates', 'availableCategoryIds', 'selectedPets']),
  },
  created() {
    this.fetchGetMemberPets()
  },
  methods: {
    async fetchCurrentMember() {
      const memberId = this.currentMemberInfo && this.currentMemberInfo.id
      if (!memberId) return
      const member = await fetchMemberShortWithSummary(this.$store, memberId)
      this.$store.commit('hotel/order/SET_MEMBER', member)
      await this.fetchGetMemberPets()
    },
    onMergeMemberInfo(member) {
      this.$store.commit('hotel/order/SET_MEMBER', member)
    },
    handleSelectedPets(pets) {
      console.log(pets)
      this.$store.commit('hotel/order/SET_PETS', [...pets])
      console.log('hey')
    },
    async fetchGetMemberPets() {
      if (!this.currentMemberInfo?.id) return
      this.isLoading = true
      try {
        this.petList = await API.order.getMemberPets(this.currentMemberInfo.id)
        if (this.selectedPetDetail && this.selectedPetDetail.id) {
          const found = this.petList.find((pet) => pet.id === this.selectedPetDetail.id)
          if (found) {
            this.selectedPetDetail = { ...found, ...(this.petDetailCache[found.id] || {}) }
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onSelectPet(pet) {
      if (!pet || !pet.id) return
      const memberId = this.currentMemberInfo && this.currentMemberInfo.id
      let detail = this.petDetailCache[pet.id]

      if (!detail && memberId) {
        try {
          const { items } = await this.$store.dispatch('member/fetchSinglePet', { memberId, petId: pet.id })
          detail = items
          if (detail) {
            this.$set(this.petDetailCache, pet.id, detail)
          }
        } catch (err) {
          console.error(err)
        }
      }

      this.selectedPetDetail = {
        ...pet,
        ...(detail || {}),
      }
    },
    async onClickViewPet(pet) {
      await this.onSelectPet(pet)
      this.petInfoActiveTab = 'information'
      this.isPetDetailDrawerShow = true
    },
    handleClosePetDetail() {
      this.isPetDetailDrawerShow = false
      this.rightPanelView = 'list'
    },
    async onPetListUpdated() {
      await this.fetchCurrentMember()
      if (this.selectedPetDetail && this.selectedPetDetail.id) {
        await this.onSelectPet(this.selectedPetDetail)
      }
    },
    async onPetInfoUpdated(payload = {}) {
      const petId = payload && payload.id ? payload.id : this.selectedPetDetail && this.selectedPetDetail.id
      if (petId) {
        this.$delete(this.petDetailCache, petId)
      }
      // 寵物信息更新後，刷新寵物列表和當前選中寵物的詳細信息
      await this.onPetListUpdated()
    },
    onPetInfoLoadingChange(isLoading) {
      this.petInfoLoading = isLoading
    },
    getCommentRef() {
      const commentRef = this.$refs.commentCurrent
      if (Array.isArray(commentRef)) {
        return commentRef.find(Boolean) || null
      }
      return commentRef || null
    },
    openCommentEdit() {
      if (!this.selectedPetId) {
        this.$message.warning('請先選擇寵物')
        return
      }
      this.isPetDetailDrawerShow = true
      this.petInfoActiveTab = 'currentService'
      this.$nextTick(() => {
        const commentRef = this.getCommentRef()
        if (commentRef && commentRef.openEdit) {
          commentRef.openEdit('new')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-layout {
  display: flex;
  height: calc(100vh - 60px); // adjust if drawer header changes
  width: 100%;
  position: relative;
  margin: 0 20px 0 50px;

  &__left {
    width: 50%;
    height: 100%;
    overflow: hidden;
    border-right: 2px solid #e6e6e6;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }

    &-header {
      position: sticky;
      top: 8px;
      padding-top: 18px;
      z-index: 10;
      background-color: #f9f9fb;
      border-bottom: 1px solid #e6e6e6;
      font-size: 18px;
      font-weight: 700;
      line-height: 2.2;
    }

    &-content {
      margin: 20px 20px 0px 0px;
    }
  }

  &__right {
    width: 50%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &-scroll {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      padding-right: 30px;
      padding-bottom: 20px;
      font-size: 16px;
      line-height: 1.8;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
        border: 2px solid #f0f0f0;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #666;
      }
    }
  }
}
</style>
